/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as LoginImport } from './routes/login'
import { Route as LayoutImport } from './routes/_layout'
import { Route as LayoutIndexImport } from './routes/_layout/index'
import { Route as LayoutMyClassesImport } from './routes/_layout/my-classes'
import { Route as Layout404Import } from './routes/_layout/404'
import { Route as Layout403Import } from './routes/_layout/403'
import { Route as LayoutUsersIndexImport } from './routes/_layout/users/index'
import { Route as LayoutTeachersIndexImport } from './routes/_layout/teachers/index'
import { Route as LayoutTeachersFeedbackIndexImport } from './routes/_layout/teachers-feedback/index'
import { Route as LayoutStudentsIndexImport } from './routes/_layout/students/index'
import { Route as LayoutStudentGroupsIndexImport } from './routes/_layout/student-groups/index'
import { Route as LayoutSessionsIndexImport } from './routes/_layout/sessions/index'
import { Route as LayoutSchoolStudentsIndexImport } from './routes/_layout/school-students/index'
import { Route as LayoutSchedulingIndexImport } from './routes/_layout/scheduling/index'
import { Route as LayoutProfileIndexImport } from './routes/_layout/profile/index'
import { Route as LayoutPaymentsIndexImport } from './routes/_layout/payments/index'
import { Route as LayoutOrgsIndexImport } from './routes/_layout/orgs/index'
import { Route as LayoutMyStudentGroupsIndexImport } from './routes/_layout/my-student-groups/index'
import { Route as LayoutMyClassesIndexImport } from './routes/_layout/my-classes/index'
import { Route as LayoutMyAvailabilityIndexImport } from './routes/_layout/my-availability/index'
import { Route as LayoutLessonsIndexImport } from './routes/_layout/lessons/index'
import { Route as LayoutHandoutsAndFeedbackIndexImport } from './routes/_layout/handouts-and-feedback/index'
import { Route as LayoutHandbookIndexImport } from './routes/_layout/handbook/index'
import { Route as LayoutGettingReadyToTeachIndexImport } from './routes/_layout/getting-ready-to-teach/index'
import { Route as LayoutBooksIndexImport } from './routes/_layout/books/index'
import { Route as LayoutAccountIndexImport } from './routes/_layout/account/index'
import { Route as LayoutUsersUserIdImport } from './routes/_layout/users/$userId'
import { Route as LayoutTeachersFeedbackFeedbackIdImport } from './routes/_layout/teachers-feedback/$feedbackId'
import { Route as LayoutSessionsSessionIdImport } from './routes/_layout/sessions/$sessionId'
import { Route as LayoutPaymentsGuidelineImport } from './routes/_layout/payments/guideline'
import { Route as LayoutMyClassesUpcomingImport } from './routes/_layout/my-classes/upcoming'
import { Route as LayoutMyClassesPastImport } from './routes/_layout/my-classes/past'
import { Route as LayoutMyClassesCalendarImport } from './routes/_layout/my-classes/calendar'
import { Route as LayoutLessonsLessonIdImport } from './routes/_layout/lessons/$lessonId'
import { Route as LayoutTeachersTqReviewIndexImport } from './routes/_layout/teachers/tq-review/index'
import { Route as LayoutTeachersTeacherPayIndexImport } from './routes/_layout/teachers/teacher-pay/index'
import { Route as LayoutTeachersOnboardingIndexImport } from './routes/_layout/teachers/onboarding/index'
import { Route as LayoutTeachersMissingZoomLicenseIndexImport } from './routes/_layout/teachers/missing-zoom-license/index'
import { Route as LayoutTeachersMissingGoogleMeetIndexImport } from './routes/_layout/teachers/missing-google-meet/index'
import { Route as LayoutTeachersGoogleMeetTqReviewIndexImport } from './routes/_layout/teachers/google-meet-tq-review/index'
import { Route as LayoutTeachersAvailabilityOverviewIndexImport } from './routes/_layout/teachers/availability-overview/index'
import { Route as LayoutTeachersAvailabilitiesIndexImport } from './routes/_layout/teachers/availabilities/index'
import { Route as LayoutTeachersAttendanceIndexImport } from './routes/_layout/teachers/attendance/index'
import { Route as LayoutTeachersAnnouncementIndexImport } from './routes/_layout/teachers/announcement/index'
import { Route as LayoutTeachersTeacherIdIndexImport } from './routes/_layout/teachers/$teacherId/index'
import { Route as LayoutStudentsNoFutureSessionsIndexImport } from './routes/_layout/students/no-future-sessions/index'
import { Route as LayoutStudentsMultipleScheduleIndexImport } from './routes/_layout/students/multiple-schedule/index'
import { Route as LayoutStudentsMakeupDiagnosticIndexImport } from './routes/_layout/students/makeup-diagnostic/index'
import { Route as LayoutStudentsLearningIssueIndexImport } from './routes/_layout/students/learning-issue/index'
import { Route as LayoutStudentsGlaIndexImport } from './routes/_layout/students/gla/index'
import { Route as LayoutStudentsDroppedIndexImport } from './routes/_layout/students/dropped/index'
import { Route as LayoutStudentsStudentIdIndexImport } from './routes/_layout/students/$studentId/index'
import { Route as LayoutStudentGroupsPendingReassignmentIndexImport } from './routes/_layout/student-groups/pending-reassignment/index'
import { Route as LayoutSessionsSubSessionsIndexImport } from './routes/_layout/sessions/sub-sessions/index'
import { Route as LayoutSessionsSessionFeedbacksIndexImport } from './routes/_layout/sessions/session-feedbacks/index'
import { Route as LayoutSessionsPastIndexImport } from './routes/_layout/sessions/past/index'
import { Route as LayoutSessionsOverlappingIndexImport } from './routes/_layout/sessions/overlapping/index'
import { Route as LayoutSessionsFutureIndexImport } from './routes/_layout/sessions/future/index'
import { Route as LayoutSchedulingSchedulesIndexImport } from './routes/_layout/scheduling/schedules/index'
import { Route as LayoutOrgsSchoolsIndexImport } from './routes/_layout/orgs/schools/index'
import { Route as LayoutOrgsOrgIdIndexImport } from './routes/_layout/orgs/$orgId/index'
import { Route as LayoutLessonsLearningPathsIndexImport } from './routes/_layout/lessons/learning-paths/index'
import { Route as LayoutLessonsAssessmentsIndexImport } from './routes/_layout/lessons/assessments/index'
import { Route as LayoutLessonsAssessmentContentsIndexImport } from './routes/_layout/lessons/assessment-contents/index'
import { Route as LayoutBooksPartIndexImport } from './routes/_layout/books/part/index'
import { Route as LayoutTeachersTeacherIdWeeklyTeachingHoursImport } from './routes/_layout/teachers/$teacherId/weekly-teaching-hours'
import { Route as LayoutTeachersTeacherIdScheduleImport } from './routes/_layout/teachers/$teacherId/schedule'
import { Route as LayoutTeachersTeacherIdReviewNotesImport } from './routes/_layout/teachers/$teacherId/review-notes'
import { Route as LayoutTeachersTeacherIdFeedbacksImport } from './routes/_layout/teachers/$teacherId/feedbacks'
import { Route as LayoutSessionsSessionFeedbacksFeedbackIdImport } from './routes/_layout/sessions/session-feedbacks/$feedbackId'
import { Route as LayoutOrgsOrgIdSettingsImport } from './routes/_layout/orgs/$orgId/settings'
import { Route as LayoutLessonsAssessmentContentsAssessmentContentIdImport } from './routes/_layout/lessons/assessment-contents/$assessmentContentId'
import { Route as LayoutBooksPartPartIdImport } from './routes/_layout/books/part/$partId'
import { Route as LayoutTeachersTeacherIdPaymentsIndexImport } from './routes/_layout/teachers/$teacherId/payments/index'
import { Route as LayoutTeachersTeacherIdPastSessionsIndexImport } from './routes/_layout/teachers/$teacherId/past-sessions/index'
import { Route as LayoutTeachersTeacherIdFutureSessionsIndexImport } from './routes/_layout/teachers/$teacherId/future-sessions/index'
import { Route as LayoutStudentsStudentIdPastStudentFeedbacksIndexImport } from './routes/_layout/students/$studentId/past-student-feedbacks/index'
import { Route as LayoutStudentsStudentIdFutureSessionsIndexImport } from './routes/_layout/students/$studentId/future-sessions/index'
import { Route as LayoutPaymentsTeachingPayCycleIdIndexImport } from './routes/_layout/payments/teaching/$payCycleId/index'
import { Route as LayoutOrgsSchoolsReportsIndexImport } from './routes/_layout/orgs/schools/reports/index'
import { Route as LayoutOrgsSchoolsSchoolIdIndexImport } from './routes/_layout/orgs/schools/$schoolId/index'
import { Route as LayoutOrgsSchoolsSchoolIdStudentsImport } from './routes/_layout/orgs/schools/$schoolId/students'
import { Route as LayoutOrgsSchoolsSchoolIdSettingsImport } from './routes/_layout/orgs/schools/$schoolId/settings'
import { Route as LayoutOrgsSchoolsSchoolIdSessionsImport } from './routes/_layout/orgs/schools/$schoolId/sessions'
import { Route as LayoutOrgsSchoolsSchoolIdSessionAttendanceImport } from './routes/_layout/orgs/schools/$schoolId/session-attendance'
import { Route as LayoutOrgsSchoolsSchoolIdSchedulesImport } from './routes/_layout/orgs/schools/$schoolId/schedules'
import { Route as LayoutOrgsSchoolsSchoolIdOneTimeClassesIndexImport } from './routes/_layout/orgs/schools/$schoolId/one-time-classes/index'
import { Route as LayoutOrgsSchoolsSchoolIdClassesIndexImport } from './routes/_layout/orgs/schools/$schoolId/classes/index'
import { Route as LayoutOrgsSchoolsSchoolIdOneTimeClassesClassIdImport } from './routes/_layout/orgs/schools/$schoolId/one-time-classes/$classId'
import { Route as LayoutOrgsSchoolsSchoolIdClassesClassIdImport } from './routes/_layout/orgs/schools/$schoolId/classes/$classId'
import { Route as LayoutTeachersTeacherIdPaymentsTeachingPayCycleIdIndexImport } from './routes/_layout/teachers/$teacherId/payments/teaching/$payCycleId/index'

// Create/Update Routes

const LoginRoute = LoginImport.update({
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const LayoutRoute = LayoutImport.update({
  id: '/_layout',
  getParentRoute: () => rootRoute,
} as any)

const LayoutIndexRoute = LayoutIndexImport.update({
  path: '/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutMyClassesRoute = LayoutMyClassesImport.update({
  path: '/my-classes',
  getParentRoute: () => LayoutRoute,
} as any)

const Layout404Route = Layout404Import.update({
  path: '/404',
  getParentRoute: () => LayoutRoute,
} as any)

const Layout403Route = Layout403Import.update({
  path: '/403',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutUsersIndexRoute = LayoutUsersIndexImport.update({
  path: '/users/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutTeachersIndexRoute = LayoutTeachersIndexImport.update({
  path: '/teachers/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutTeachersFeedbackIndexRoute =
  LayoutTeachersFeedbackIndexImport.update({
    path: '/teachers-feedback/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutStudentsIndexRoute = LayoutStudentsIndexImport.update({
  path: '/students/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutStudentGroupsIndexRoute = LayoutStudentGroupsIndexImport.update({
  path: '/student-groups/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutSessionsIndexRoute = LayoutSessionsIndexImport.update({
  path: '/sessions/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutSchoolStudentsIndexRoute = LayoutSchoolStudentsIndexImport.update({
  path: '/school-students/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutSchedulingIndexRoute = LayoutSchedulingIndexImport.update({
  path: '/scheduling/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutProfileIndexRoute = LayoutProfileIndexImport.update({
  path: '/profile/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutPaymentsIndexRoute = LayoutPaymentsIndexImport.update({
  path: '/payments/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutOrgsIndexRoute = LayoutOrgsIndexImport.update({
  path: '/orgs/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutMyStudentGroupsIndexRoute = LayoutMyStudentGroupsIndexImport.update(
  {
    path: '/my-student-groups/',
    getParentRoute: () => LayoutRoute,
  } as any,
)

const LayoutMyClassesIndexRoute = LayoutMyClassesIndexImport.update({
  path: '/',
  getParentRoute: () => LayoutMyClassesRoute,
} as any)

const LayoutMyAvailabilityIndexRoute = LayoutMyAvailabilityIndexImport.update({
  path: '/my-availability/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutLessonsIndexRoute = LayoutLessonsIndexImport.update({
  path: '/lessons/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutHandoutsAndFeedbackIndexRoute =
  LayoutHandoutsAndFeedbackIndexImport.update({
    path: '/handouts-and-feedback/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutHandbookIndexRoute = LayoutHandbookIndexImport.update({
  path: '/handbook/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutGettingReadyToTeachIndexRoute =
  LayoutGettingReadyToTeachIndexImport.update({
    path: '/getting-ready-to-teach/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutBooksIndexRoute = LayoutBooksIndexImport.update({
  path: '/books/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutAccountIndexRoute = LayoutAccountIndexImport.update({
  path: '/account/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutUsersUserIdRoute = LayoutUsersUserIdImport.update({
  path: '/users/$userId',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutTeachersFeedbackFeedbackIdRoute =
  LayoutTeachersFeedbackFeedbackIdImport.update({
    path: '/teachers-feedback/$feedbackId',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutSessionsSessionIdRoute = LayoutSessionsSessionIdImport.update({
  path: '/sessions/$sessionId',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutPaymentsGuidelineRoute = LayoutPaymentsGuidelineImport.update({
  path: '/payments/guideline',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutMyClassesUpcomingRoute = LayoutMyClassesUpcomingImport.update({
  path: '/upcoming',
  getParentRoute: () => LayoutMyClassesRoute,
} as any)

const LayoutMyClassesPastRoute = LayoutMyClassesPastImport.update({
  path: '/past',
  getParentRoute: () => LayoutMyClassesRoute,
} as any)

const LayoutMyClassesCalendarRoute = LayoutMyClassesCalendarImport.update({
  path: '/calendar',
  getParentRoute: () => LayoutMyClassesRoute,
} as any)

const LayoutLessonsLessonIdRoute = LayoutLessonsLessonIdImport.update({
  path: '/lessons/$lessonId',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutTeachersTqReviewIndexRoute =
  LayoutTeachersTqReviewIndexImport.update({
    path: '/teachers/tq-review/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutTeachersTeacherPayIndexRoute =
  LayoutTeachersTeacherPayIndexImport.update({
    path: '/teachers/teacher-pay/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutTeachersOnboardingIndexRoute =
  LayoutTeachersOnboardingIndexImport.update({
    path: '/teachers/onboarding/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutTeachersMissingZoomLicenseIndexRoute =
  LayoutTeachersMissingZoomLicenseIndexImport.update({
    path: '/teachers/missing-zoom-license/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutTeachersMissingGoogleMeetIndexRoute =
  LayoutTeachersMissingGoogleMeetIndexImport.update({
    path: '/teachers/missing-google-meet/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutTeachersGoogleMeetTqReviewIndexRoute =
  LayoutTeachersGoogleMeetTqReviewIndexImport.update({
    path: '/teachers/google-meet-tq-review/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutTeachersAvailabilityOverviewIndexRoute =
  LayoutTeachersAvailabilityOverviewIndexImport.update({
    path: '/teachers/availability-overview/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutTeachersAvailabilitiesIndexRoute =
  LayoutTeachersAvailabilitiesIndexImport.update({
    path: '/teachers/availabilities/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutTeachersAttendanceIndexRoute =
  LayoutTeachersAttendanceIndexImport.update({
    path: '/teachers/attendance/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutTeachersAnnouncementIndexRoute =
  LayoutTeachersAnnouncementIndexImport.update({
    path: '/teachers/announcement/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutTeachersTeacherIdIndexRoute =
  LayoutTeachersTeacherIdIndexImport.update({
    path: '/teachers/$teacherId/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutStudentsNoFutureSessionsIndexRoute =
  LayoutStudentsNoFutureSessionsIndexImport.update({
    path: '/students/no-future-sessions/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutStudentsMultipleScheduleIndexRoute =
  LayoutStudentsMultipleScheduleIndexImport.update({
    path: '/students/multiple-schedule/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutStudentsMakeupDiagnosticIndexRoute =
  LayoutStudentsMakeupDiagnosticIndexImport.update({
    path: '/students/makeup-diagnostic/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutStudentsLearningIssueIndexRoute =
  LayoutStudentsLearningIssueIndexImport.update({
    path: '/students/learning-issue/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutStudentsGlaIndexRoute = LayoutStudentsGlaIndexImport.update({
  path: '/students/gla/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutStudentsDroppedIndexRoute = LayoutStudentsDroppedIndexImport.update(
  {
    path: '/students/dropped/',
    getParentRoute: () => LayoutRoute,
  } as any,
)

const LayoutStudentsStudentIdIndexRoute =
  LayoutStudentsStudentIdIndexImport.update({
    path: '/students/$studentId/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutStudentGroupsPendingReassignmentIndexRoute =
  LayoutStudentGroupsPendingReassignmentIndexImport.update({
    path: '/student-groups/pending-reassignment/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutSessionsSubSessionsIndexRoute =
  LayoutSessionsSubSessionsIndexImport.update({
    path: '/sessions/sub-sessions/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutSessionsSessionFeedbacksIndexRoute =
  LayoutSessionsSessionFeedbacksIndexImport.update({
    path: '/sessions/session-feedbacks/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutSessionsPastIndexRoute = LayoutSessionsPastIndexImport.update({
  path: '/sessions/past/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutSessionsOverlappingIndexRoute =
  LayoutSessionsOverlappingIndexImport.update({
    path: '/sessions/overlapping/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutSessionsFutureIndexRoute = LayoutSessionsFutureIndexImport.update({
  path: '/sessions/future/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutSchedulingSchedulesIndexRoute =
  LayoutSchedulingSchedulesIndexImport.update({
    path: '/scheduling/schedules/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutOrgsSchoolsIndexRoute = LayoutOrgsSchoolsIndexImport.update({
  path: '/orgs/schools/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutOrgsOrgIdIndexRoute = LayoutOrgsOrgIdIndexImport.update({
  path: '/orgs/$orgId/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutLessonsLearningPathsIndexRoute =
  LayoutLessonsLearningPathsIndexImport.update({
    path: '/lessons/learning-paths/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutLessonsAssessmentsIndexRoute =
  LayoutLessonsAssessmentsIndexImport.update({
    path: '/lessons/assessments/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutLessonsAssessmentContentsIndexRoute =
  LayoutLessonsAssessmentContentsIndexImport.update({
    path: '/lessons/assessment-contents/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutBooksPartIndexRoute = LayoutBooksPartIndexImport.update({
  path: '/books/part/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutTeachersTeacherIdWeeklyTeachingHoursRoute =
  LayoutTeachersTeacherIdWeeklyTeachingHoursImport.update({
    path: '/teachers/$teacherId/weekly-teaching-hours',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutTeachersTeacherIdScheduleRoute =
  LayoutTeachersTeacherIdScheduleImport.update({
    path: '/teachers/$teacherId/schedule',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutTeachersTeacherIdReviewNotesRoute =
  LayoutTeachersTeacherIdReviewNotesImport.update({
    path: '/teachers/$teacherId/review-notes',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutTeachersTeacherIdFeedbacksRoute =
  LayoutTeachersTeacherIdFeedbacksImport.update({
    path: '/teachers/$teacherId/feedbacks',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutSessionsSessionFeedbacksFeedbackIdRoute =
  LayoutSessionsSessionFeedbacksFeedbackIdImport.update({
    path: '/sessions/session-feedbacks/$feedbackId',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutOrgsOrgIdSettingsRoute = LayoutOrgsOrgIdSettingsImport.update({
  path: '/orgs/$orgId/settings',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutLessonsAssessmentContentsAssessmentContentIdRoute =
  LayoutLessonsAssessmentContentsAssessmentContentIdImport.update({
    path: '/lessons/assessment-contents/$assessmentContentId',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutBooksPartPartIdRoute = LayoutBooksPartPartIdImport.update({
  path: '/books/part/$partId',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutTeachersTeacherIdPaymentsIndexRoute =
  LayoutTeachersTeacherIdPaymentsIndexImport.update({
    path: '/teachers/$teacherId/payments/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutTeachersTeacherIdPastSessionsIndexRoute =
  LayoutTeachersTeacherIdPastSessionsIndexImport.update({
    path: '/teachers/$teacherId/past-sessions/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutTeachersTeacherIdFutureSessionsIndexRoute =
  LayoutTeachersTeacherIdFutureSessionsIndexImport.update({
    path: '/teachers/$teacherId/future-sessions/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutStudentsStudentIdPastStudentFeedbacksIndexRoute =
  LayoutStudentsStudentIdPastStudentFeedbacksIndexImport.update({
    path: '/students/$studentId/past-student-feedbacks/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutStudentsStudentIdFutureSessionsIndexRoute =
  LayoutStudentsStudentIdFutureSessionsIndexImport.update({
    path: '/students/$studentId/future-sessions/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutPaymentsTeachingPayCycleIdIndexRoute =
  LayoutPaymentsTeachingPayCycleIdIndexImport.update({
    path: '/payments/teaching/$payCycleId/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutOrgsSchoolsReportsIndexRoute =
  LayoutOrgsSchoolsReportsIndexImport.update({
    path: '/orgs/schools/reports/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutOrgsSchoolsSchoolIdIndexRoute =
  LayoutOrgsSchoolsSchoolIdIndexImport.update({
    path: '/orgs/schools/$schoolId/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutOrgsSchoolsSchoolIdStudentsRoute =
  LayoutOrgsSchoolsSchoolIdStudentsImport.update({
    path: '/orgs/schools/$schoolId/students',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutOrgsSchoolsSchoolIdSettingsRoute =
  LayoutOrgsSchoolsSchoolIdSettingsImport.update({
    path: '/orgs/schools/$schoolId/settings',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutOrgsSchoolsSchoolIdSessionsRoute =
  LayoutOrgsSchoolsSchoolIdSessionsImport.update({
    path: '/orgs/schools/$schoolId/sessions',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutOrgsSchoolsSchoolIdSessionAttendanceRoute =
  LayoutOrgsSchoolsSchoolIdSessionAttendanceImport.update({
    path: '/orgs/schools/$schoolId/session-attendance',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutOrgsSchoolsSchoolIdSchedulesRoute =
  LayoutOrgsSchoolsSchoolIdSchedulesImport.update({
    path: '/orgs/schools/$schoolId/schedules',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutOrgsSchoolsSchoolIdOneTimeClassesIndexRoute =
  LayoutOrgsSchoolsSchoolIdOneTimeClassesIndexImport.update({
    path: '/orgs/schools/$schoolId/one-time-classes/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutOrgsSchoolsSchoolIdClassesIndexRoute =
  LayoutOrgsSchoolsSchoolIdClassesIndexImport.update({
    path: '/orgs/schools/$schoolId/classes/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutOrgsSchoolsSchoolIdOneTimeClassesClassIdRoute =
  LayoutOrgsSchoolsSchoolIdOneTimeClassesClassIdImport.update({
    path: '/orgs/schools/$schoolId/one-time-classes/$classId',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutOrgsSchoolsSchoolIdClassesClassIdRoute =
  LayoutOrgsSchoolsSchoolIdClassesClassIdImport.update({
    path: '/orgs/schools/$schoolId/classes/$classId',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutTeachersTeacherIdPaymentsTeachingPayCycleIdIndexRoute =
  LayoutTeachersTeacherIdPaymentsTeachingPayCycleIdIndexImport.update({
    path: '/teachers/$teacherId/payments/teaching/$payCycleId/',
    getParentRoute: () => LayoutRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LayoutImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/_layout/403': {
      id: '/_layout/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof Layout403Import
      parentRoute: typeof LayoutImport
    }
    '/_layout/404': {
      id: '/_layout/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof Layout404Import
      parentRoute: typeof LayoutImport
    }
    '/_layout/my-classes': {
      id: '/_layout/my-classes'
      path: '/my-classes'
      fullPath: '/my-classes'
      preLoaderRoute: typeof LayoutMyClassesImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/': {
      id: '/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LayoutIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/lessons/$lessonId': {
      id: '/_layout/lessons/$lessonId'
      path: '/lessons/$lessonId'
      fullPath: '/lessons/$lessonId'
      preLoaderRoute: typeof LayoutLessonsLessonIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/my-classes/calendar': {
      id: '/_layout/my-classes/calendar'
      path: '/calendar'
      fullPath: '/my-classes/calendar'
      preLoaderRoute: typeof LayoutMyClassesCalendarImport
      parentRoute: typeof LayoutMyClassesImport
    }
    '/_layout/my-classes/past': {
      id: '/_layout/my-classes/past'
      path: '/past'
      fullPath: '/my-classes/past'
      preLoaderRoute: typeof LayoutMyClassesPastImport
      parentRoute: typeof LayoutMyClassesImport
    }
    '/_layout/my-classes/upcoming': {
      id: '/_layout/my-classes/upcoming'
      path: '/upcoming'
      fullPath: '/my-classes/upcoming'
      preLoaderRoute: typeof LayoutMyClassesUpcomingImport
      parentRoute: typeof LayoutMyClassesImport
    }
    '/_layout/payments/guideline': {
      id: '/_layout/payments/guideline'
      path: '/payments/guideline'
      fullPath: '/payments/guideline'
      preLoaderRoute: typeof LayoutPaymentsGuidelineImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/sessions/$sessionId': {
      id: '/_layout/sessions/$sessionId'
      path: '/sessions/$sessionId'
      fullPath: '/sessions/$sessionId'
      preLoaderRoute: typeof LayoutSessionsSessionIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/teachers-feedback/$feedbackId': {
      id: '/_layout/teachers-feedback/$feedbackId'
      path: '/teachers-feedback/$feedbackId'
      fullPath: '/teachers-feedback/$feedbackId'
      preLoaderRoute: typeof LayoutTeachersFeedbackFeedbackIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/users/$userId': {
      id: '/_layout/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof LayoutUsersUserIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/account/': {
      id: '/_layout/account/'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof LayoutAccountIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/books/': {
      id: '/_layout/books/'
      path: '/books'
      fullPath: '/books'
      preLoaderRoute: typeof LayoutBooksIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/getting-ready-to-teach/': {
      id: '/_layout/getting-ready-to-teach/'
      path: '/getting-ready-to-teach'
      fullPath: '/getting-ready-to-teach'
      preLoaderRoute: typeof LayoutGettingReadyToTeachIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/handbook/': {
      id: '/_layout/handbook/'
      path: '/handbook'
      fullPath: '/handbook'
      preLoaderRoute: typeof LayoutHandbookIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/handouts-and-feedback/': {
      id: '/_layout/handouts-and-feedback/'
      path: '/handouts-and-feedback'
      fullPath: '/handouts-and-feedback'
      preLoaderRoute: typeof LayoutHandoutsAndFeedbackIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/lessons/': {
      id: '/_layout/lessons/'
      path: '/lessons'
      fullPath: '/lessons'
      preLoaderRoute: typeof LayoutLessonsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/my-availability/': {
      id: '/_layout/my-availability/'
      path: '/my-availability'
      fullPath: '/my-availability'
      preLoaderRoute: typeof LayoutMyAvailabilityIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/my-classes/': {
      id: '/_layout/my-classes/'
      path: '/'
      fullPath: '/my-classes/'
      preLoaderRoute: typeof LayoutMyClassesIndexImport
      parentRoute: typeof LayoutMyClassesImport
    }
    '/_layout/my-student-groups/': {
      id: '/_layout/my-student-groups/'
      path: '/my-student-groups'
      fullPath: '/my-student-groups'
      preLoaderRoute: typeof LayoutMyStudentGroupsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/orgs/': {
      id: '/_layout/orgs/'
      path: '/orgs'
      fullPath: '/orgs'
      preLoaderRoute: typeof LayoutOrgsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/payments/': {
      id: '/_layout/payments/'
      path: '/payments'
      fullPath: '/payments'
      preLoaderRoute: typeof LayoutPaymentsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/profile/': {
      id: '/_layout/profile/'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof LayoutProfileIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/scheduling/': {
      id: '/_layout/scheduling/'
      path: '/scheduling'
      fullPath: '/scheduling'
      preLoaderRoute: typeof LayoutSchedulingIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/school-students/': {
      id: '/_layout/school-students/'
      path: '/school-students'
      fullPath: '/school-students'
      preLoaderRoute: typeof LayoutSchoolStudentsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/sessions/': {
      id: '/_layout/sessions/'
      path: '/sessions'
      fullPath: '/sessions'
      preLoaderRoute: typeof LayoutSessionsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/student-groups/': {
      id: '/_layout/student-groups/'
      path: '/student-groups'
      fullPath: '/student-groups'
      preLoaderRoute: typeof LayoutStudentGroupsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/students/': {
      id: '/_layout/students/'
      path: '/students'
      fullPath: '/students'
      preLoaderRoute: typeof LayoutStudentsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/teachers-feedback/': {
      id: '/_layout/teachers-feedback/'
      path: '/teachers-feedback'
      fullPath: '/teachers-feedback'
      preLoaderRoute: typeof LayoutTeachersFeedbackIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/teachers/': {
      id: '/_layout/teachers/'
      path: '/teachers'
      fullPath: '/teachers'
      preLoaderRoute: typeof LayoutTeachersIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/users/': {
      id: '/_layout/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof LayoutUsersIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/books/part/$partId': {
      id: '/_layout/books/part/$partId'
      path: '/books/part/$partId'
      fullPath: '/books/part/$partId'
      preLoaderRoute: typeof LayoutBooksPartPartIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/lessons/assessment-contents/$assessmentContentId': {
      id: '/_layout/lessons/assessment-contents/$assessmentContentId'
      path: '/lessons/assessment-contents/$assessmentContentId'
      fullPath: '/lessons/assessment-contents/$assessmentContentId'
      preLoaderRoute: typeof LayoutLessonsAssessmentContentsAssessmentContentIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/orgs/$orgId/settings': {
      id: '/_layout/orgs/$orgId/settings'
      path: '/orgs/$orgId/settings'
      fullPath: '/orgs/$orgId/settings'
      preLoaderRoute: typeof LayoutOrgsOrgIdSettingsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/sessions/session-feedbacks/$feedbackId': {
      id: '/_layout/sessions/session-feedbacks/$feedbackId'
      path: '/sessions/session-feedbacks/$feedbackId'
      fullPath: '/sessions/session-feedbacks/$feedbackId'
      preLoaderRoute: typeof LayoutSessionsSessionFeedbacksFeedbackIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/teachers/$teacherId/feedbacks': {
      id: '/_layout/teachers/$teacherId/feedbacks'
      path: '/teachers/$teacherId/feedbacks'
      fullPath: '/teachers/$teacherId/feedbacks'
      preLoaderRoute: typeof LayoutTeachersTeacherIdFeedbacksImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/teachers/$teacherId/review-notes': {
      id: '/_layout/teachers/$teacherId/review-notes'
      path: '/teachers/$teacherId/review-notes'
      fullPath: '/teachers/$teacherId/review-notes'
      preLoaderRoute: typeof LayoutTeachersTeacherIdReviewNotesImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/teachers/$teacherId/schedule': {
      id: '/_layout/teachers/$teacherId/schedule'
      path: '/teachers/$teacherId/schedule'
      fullPath: '/teachers/$teacherId/schedule'
      preLoaderRoute: typeof LayoutTeachersTeacherIdScheduleImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/teachers/$teacherId/weekly-teaching-hours': {
      id: '/_layout/teachers/$teacherId/weekly-teaching-hours'
      path: '/teachers/$teacherId/weekly-teaching-hours'
      fullPath: '/teachers/$teacherId/weekly-teaching-hours'
      preLoaderRoute: typeof LayoutTeachersTeacherIdWeeklyTeachingHoursImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/books/part/': {
      id: '/_layout/books/part/'
      path: '/books/part'
      fullPath: '/books/part'
      preLoaderRoute: typeof LayoutBooksPartIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/lessons/assessment-contents/': {
      id: '/_layout/lessons/assessment-contents/'
      path: '/lessons/assessment-contents'
      fullPath: '/lessons/assessment-contents'
      preLoaderRoute: typeof LayoutLessonsAssessmentContentsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/lessons/assessments/': {
      id: '/_layout/lessons/assessments/'
      path: '/lessons/assessments'
      fullPath: '/lessons/assessments'
      preLoaderRoute: typeof LayoutLessonsAssessmentsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/lessons/learning-paths/': {
      id: '/_layout/lessons/learning-paths/'
      path: '/lessons/learning-paths'
      fullPath: '/lessons/learning-paths'
      preLoaderRoute: typeof LayoutLessonsLearningPathsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/orgs/$orgId/': {
      id: '/_layout/orgs/$orgId/'
      path: '/orgs/$orgId'
      fullPath: '/orgs/$orgId'
      preLoaderRoute: typeof LayoutOrgsOrgIdIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/orgs/schools/': {
      id: '/_layout/orgs/schools/'
      path: '/orgs/schools'
      fullPath: '/orgs/schools'
      preLoaderRoute: typeof LayoutOrgsSchoolsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/scheduling/schedules/': {
      id: '/_layout/scheduling/schedules/'
      path: '/scheduling/schedules'
      fullPath: '/scheduling/schedules'
      preLoaderRoute: typeof LayoutSchedulingSchedulesIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/sessions/future/': {
      id: '/_layout/sessions/future/'
      path: '/sessions/future'
      fullPath: '/sessions/future'
      preLoaderRoute: typeof LayoutSessionsFutureIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/sessions/overlapping/': {
      id: '/_layout/sessions/overlapping/'
      path: '/sessions/overlapping'
      fullPath: '/sessions/overlapping'
      preLoaderRoute: typeof LayoutSessionsOverlappingIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/sessions/past/': {
      id: '/_layout/sessions/past/'
      path: '/sessions/past'
      fullPath: '/sessions/past'
      preLoaderRoute: typeof LayoutSessionsPastIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/sessions/session-feedbacks/': {
      id: '/_layout/sessions/session-feedbacks/'
      path: '/sessions/session-feedbacks'
      fullPath: '/sessions/session-feedbacks'
      preLoaderRoute: typeof LayoutSessionsSessionFeedbacksIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/sessions/sub-sessions/': {
      id: '/_layout/sessions/sub-sessions/'
      path: '/sessions/sub-sessions'
      fullPath: '/sessions/sub-sessions'
      preLoaderRoute: typeof LayoutSessionsSubSessionsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/student-groups/pending-reassignment/': {
      id: '/_layout/student-groups/pending-reassignment/'
      path: '/student-groups/pending-reassignment'
      fullPath: '/student-groups/pending-reassignment'
      preLoaderRoute: typeof LayoutStudentGroupsPendingReassignmentIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/students/$studentId/': {
      id: '/_layout/students/$studentId/'
      path: '/students/$studentId'
      fullPath: '/students/$studentId'
      preLoaderRoute: typeof LayoutStudentsStudentIdIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/students/dropped/': {
      id: '/_layout/students/dropped/'
      path: '/students/dropped'
      fullPath: '/students/dropped'
      preLoaderRoute: typeof LayoutStudentsDroppedIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/students/gla/': {
      id: '/_layout/students/gla/'
      path: '/students/gla'
      fullPath: '/students/gla'
      preLoaderRoute: typeof LayoutStudentsGlaIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/students/learning-issue/': {
      id: '/_layout/students/learning-issue/'
      path: '/students/learning-issue'
      fullPath: '/students/learning-issue'
      preLoaderRoute: typeof LayoutStudentsLearningIssueIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/students/makeup-diagnostic/': {
      id: '/_layout/students/makeup-diagnostic/'
      path: '/students/makeup-diagnostic'
      fullPath: '/students/makeup-diagnostic'
      preLoaderRoute: typeof LayoutStudentsMakeupDiagnosticIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/students/multiple-schedule/': {
      id: '/_layout/students/multiple-schedule/'
      path: '/students/multiple-schedule'
      fullPath: '/students/multiple-schedule'
      preLoaderRoute: typeof LayoutStudentsMultipleScheduleIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/students/no-future-sessions/': {
      id: '/_layout/students/no-future-sessions/'
      path: '/students/no-future-sessions'
      fullPath: '/students/no-future-sessions'
      preLoaderRoute: typeof LayoutStudentsNoFutureSessionsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/teachers/$teacherId/': {
      id: '/_layout/teachers/$teacherId/'
      path: '/teachers/$teacherId'
      fullPath: '/teachers/$teacherId'
      preLoaderRoute: typeof LayoutTeachersTeacherIdIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/teachers/announcement/': {
      id: '/_layout/teachers/announcement/'
      path: '/teachers/announcement'
      fullPath: '/teachers/announcement'
      preLoaderRoute: typeof LayoutTeachersAnnouncementIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/teachers/attendance/': {
      id: '/_layout/teachers/attendance/'
      path: '/teachers/attendance'
      fullPath: '/teachers/attendance'
      preLoaderRoute: typeof LayoutTeachersAttendanceIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/teachers/availabilities/': {
      id: '/_layout/teachers/availabilities/'
      path: '/teachers/availabilities'
      fullPath: '/teachers/availabilities'
      preLoaderRoute: typeof LayoutTeachersAvailabilitiesIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/teachers/availability-overview/': {
      id: '/_layout/teachers/availability-overview/'
      path: '/teachers/availability-overview'
      fullPath: '/teachers/availability-overview'
      preLoaderRoute: typeof LayoutTeachersAvailabilityOverviewIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/teachers/google-meet-tq-review/': {
      id: '/_layout/teachers/google-meet-tq-review/'
      path: '/teachers/google-meet-tq-review'
      fullPath: '/teachers/google-meet-tq-review'
      preLoaderRoute: typeof LayoutTeachersGoogleMeetTqReviewIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/teachers/missing-google-meet/': {
      id: '/_layout/teachers/missing-google-meet/'
      path: '/teachers/missing-google-meet'
      fullPath: '/teachers/missing-google-meet'
      preLoaderRoute: typeof LayoutTeachersMissingGoogleMeetIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/teachers/missing-zoom-license/': {
      id: '/_layout/teachers/missing-zoom-license/'
      path: '/teachers/missing-zoom-license'
      fullPath: '/teachers/missing-zoom-license'
      preLoaderRoute: typeof LayoutTeachersMissingZoomLicenseIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/teachers/onboarding/': {
      id: '/_layout/teachers/onboarding/'
      path: '/teachers/onboarding'
      fullPath: '/teachers/onboarding'
      preLoaderRoute: typeof LayoutTeachersOnboardingIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/teachers/teacher-pay/': {
      id: '/_layout/teachers/teacher-pay/'
      path: '/teachers/teacher-pay'
      fullPath: '/teachers/teacher-pay'
      preLoaderRoute: typeof LayoutTeachersTeacherPayIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/teachers/tq-review/': {
      id: '/_layout/teachers/tq-review/'
      path: '/teachers/tq-review'
      fullPath: '/teachers/tq-review'
      preLoaderRoute: typeof LayoutTeachersTqReviewIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/orgs/schools/$schoolId/schedules': {
      id: '/_layout/orgs/schools/$schoolId/schedules'
      path: '/orgs/schools/$schoolId/schedules'
      fullPath: '/orgs/schools/$schoolId/schedules'
      preLoaderRoute: typeof LayoutOrgsSchoolsSchoolIdSchedulesImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/orgs/schools/$schoolId/session-attendance': {
      id: '/_layout/orgs/schools/$schoolId/session-attendance'
      path: '/orgs/schools/$schoolId/session-attendance'
      fullPath: '/orgs/schools/$schoolId/session-attendance'
      preLoaderRoute: typeof LayoutOrgsSchoolsSchoolIdSessionAttendanceImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/orgs/schools/$schoolId/sessions': {
      id: '/_layout/orgs/schools/$schoolId/sessions'
      path: '/orgs/schools/$schoolId/sessions'
      fullPath: '/orgs/schools/$schoolId/sessions'
      preLoaderRoute: typeof LayoutOrgsSchoolsSchoolIdSessionsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/orgs/schools/$schoolId/settings': {
      id: '/_layout/orgs/schools/$schoolId/settings'
      path: '/orgs/schools/$schoolId/settings'
      fullPath: '/orgs/schools/$schoolId/settings'
      preLoaderRoute: typeof LayoutOrgsSchoolsSchoolIdSettingsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/orgs/schools/$schoolId/students': {
      id: '/_layout/orgs/schools/$schoolId/students'
      path: '/orgs/schools/$schoolId/students'
      fullPath: '/orgs/schools/$schoolId/students'
      preLoaderRoute: typeof LayoutOrgsSchoolsSchoolIdStudentsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/orgs/schools/$schoolId/': {
      id: '/_layout/orgs/schools/$schoolId/'
      path: '/orgs/schools/$schoolId'
      fullPath: '/orgs/schools/$schoolId'
      preLoaderRoute: typeof LayoutOrgsSchoolsSchoolIdIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/orgs/schools/reports/': {
      id: '/_layout/orgs/schools/reports/'
      path: '/orgs/schools/reports'
      fullPath: '/orgs/schools/reports'
      preLoaderRoute: typeof LayoutOrgsSchoolsReportsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/payments/teaching/$payCycleId/': {
      id: '/_layout/payments/teaching/$payCycleId/'
      path: '/payments/teaching/$payCycleId'
      fullPath: '/payments/teaching/$payCycleId'
      preLoaderRoute: typeof LayoutPaymentsTeachingPayCycleIdIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/students/$studentId/future-sessions/': {
      id: '/_layout/students/$studentId/future-sessions/'
      path: '/students/$studentId/future-sessions'
      fullPath: '/students/$studentId/future-sessions'
      preLoaderRoute: typeof LayoutStudentsStudentIdFutureSessionsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/students/$studentId/past-student-feedbacks/': {
      id: '/_layout/students/$studentId/past-student-feedbacks/'
      path: '/students/$studentId/past-student-feedbacks'
      fullPath: '/students/$studentId/past-student-feedbacks'
      preLoaderRoute: typeof LayoutStudentsStudentIdPastStudentFeedbacksIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/teachers/$teacherId/future-sessions/': {
      id: '/_layout/teachers/$teacherId/future-sessions/'
      path: '/teachers/$teacherId/future-sessions'
      fullPath: '/teachers/$teacherId/future-sessions'
      preLoaderRoute: typeof LayoutTeachersTeacherIdFutureSessionsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/teachers/$teacherId/past-sessions/': {
      id: '/_layout/teachers/$teacherId/past-sessions/'
      path: '/teachers/$teacherId/past-sessions'
      fullPath: '/teachers/$teacherId/past-sessions'
      preLoaderRoute: typeof LayoutTeachersTeacherIdPastSessionsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/teachers/$teacherId/payments/': {
      id: '/_layout/teachers/$teacherId/payments/'
      path: '/teachers/$teacherId/payments'
      fullPath: '/teachers/$teacherId/payments'
      preLoaderRoute: typeof LayoutTeachersTeacherIdPaymentsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/orgs/schools/$schoolId/classes/$classId': {
      id: '/_layout/orgs/schools/$schoolId/classes/$classId'
      path: '/orgs/schools/$schoolId/classes/$classId'
      fullPath: '/orgs/schools/$schoolId/classes/$classId'
      preLoaderRoute: typeof LayoutOrgsSchoolsSchoolIdClassesClassIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/orgs/schools/$schoolId/one-time-classes/$classId': {
      id: '/_layout/orgs/schools/$schoolId/one-time-classes/$classId'
      path: '/orgs/schools/$schoolId/one-time-classes/$classId'
      fullPath: '/orgs/schools/$schoolId/one-time-classes/$classId'
      preLoaderRoute: typeof LayoutOrgsSchoolsSchoolIdOneTimeClassesClassIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/orgs/schools/$schoolId/classes/': {
      id: '/_layout/orgs/schools/$schoolId/classes/'
      path: '/orgs/schools/$schoolId/classes'
      fullPath: '/orgs/schools/$schoolId/classes'
      preLoaderRoute: typeof LayoutOrgsSchoolsSchoolIdClassesIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/orgs/schools/$schoolId/one-time-classes/': {
      id: '/_layout/orgs/schools/$schoolId/one-time-classes/'
      path: '/orgs/schools/$schoolId/one-time-classes'
      fullPath: '/orgs/schools/$schoolId/one-time-classes'
      preLoaderRoute: typeof LayoutOrgsSchoolsSchoolIdOneTimeClassesIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/teachers/$teacherId/payments/teaching/$payCycleId/': {
      id: '/_layout/teachers/$teacherId/payments/teaching/$payCycleId/'
      path: '/teachers/$teacherId/payments/teaching/$payCycleId'
      fullPath: '/teachers/$teacherId/payments/teaching/$payCycleId'
      preLoaderRoute: typeof LayoutTeachersTeacherIdPaymentsTeachingPayCycleIdIndexImport
      parentRoute: typeof LayoutImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  LayoutRoute: LayoutRoute.addChildren({
    Layout403Route,
    Layout404Route,
    LayoutMyClassesRoute: LayoutMyClassesRoute.addChildren({
      LayoutMyClassesCalendarRoute,
      LayoutMyClassesPastRoute,
      LayoutMyClassesUpcomingRoute,
      LayoutMyClassesIndexRoute,
    }),
    LayoutIndexRoute,
    LayoutLessonsLessonIdRoute,
    LayoutPaymentsGuidelineRoute,
    LayoutSessionsSessionIdRoute,
    LayoutTeachersFeedbackFeedbackIdRoute,
    LayoutUsersUserIdRoute,
    LayoutAccountIndexRoute,
    LayoutBooksIndexRoute,
    LayoutGettingReadyToTeachIndexRoute,
    LayoutHandbookIndexRoute,
    LayoutHandoutsAndFeedbackIndexRoute,
    LayoutLessonsIndexRoute,
    LayoutMyAvailabilityIndexRoute,
    LayoutMyStudentGroupsIndexRoute,
    LayoutOrgsIndexRoute,
    LayoutPaymentsIndexRoute,
    LayoutProfileIndexRoute,
    LayoutSchedulingIndexRoute,
    LayoutSchoolStudentsIndexRoute,
    LayoutSessionsIndexRoute,
    LayoutStudentGroupsIndexRoute,
    LayoutStudentsIndexRoute,
    LayoutTeachersFeedbackIndexRoute,
    LayoutTeachersIndexRoute,
    LayoutUsersIndexRoute,
    LayoutBooksPartPartIdRoute,
    LayoutLessonsAssessmentContentsAssessmentContentIdRoute,
    LayoutOrgsOrgIdSettingsRoute,
    LayoutSessionsSessionFeedbacksFeedbackIdRoute,
    LayoutTeachersTeacherIdFeedbacksRoute,
    LayoutTeachersTeacherIdReviewNotesRoute,
    LayoutTeachersTeacherIdScheduleRoute,
    LayoutTeachersTeacherIdWeeklyTeachingHoursRoute,
    LayoutBooksPartIndexRoute,
    LayoutLessonsAssessmentContentsIndexRoute,
    LayoutLessonsAssessmentsIndexRoute,
    LayoutLessonsLearningPathsIndexRoute,
    LayoutOrgsOrgIdIndexRoute,
    LayoutOrgsSchoolsIndexRoute,
    LayoutSchedulingSchedulesIndexRoute,
    LayoutSessionsFutureIndexRoute,
    LayoutSessionsOverlappingIndexRoute,
    LayoutSessionsPastIndexRoute,
    LayoutSessionsSessionFeedbacksIndexRoute,
    LayoutSessionsSubSessionsIndexRoute,
    LayoutStudentGroupsPendingReassignmentIndexRoute,
    LayoutStudentsStudentIdIndexRoute,
    LayoutStudentsDroppedIndexRoute,
    LayoutStudentsGlaIndexRoute,
    LayoutStudentsLearningIssueIndexRoute,
    LayoutStudentsMakeupDiagnosticIndexRoute,
    LayoutStudentsMultipleScheduleIndexRoute,
    LayoutStudentsNoFutureSessionsIndexRoute,
    LayoutTeachersTeacherIdIndexRoute,
    LayoutTeachersAnnouncementIndexRoute,
    LayoutTeachersAttendanceIndexRoute,
    LayoutTeachersAvailabilitiesIndexRoute,
    LayoutTeachersAvailabilityOverviewIndexRoute,
    LayoutTeachersGoogleMeetTqReviewIndexRoute,
    LayoutTeachersMissingGoogleMeetIndexRoute,
    LayoutTeachersMissingZoomLicenseIndexRoute,
    LayoutTeachersOnboardingIndexRoute,
    LayoutTeachersTeacherPayIndexRoute,
    LayoutTeachersTqReviewIndexRoute,
    LayoutOrgsSchoolsSchoolIdSchedulesRoute,
    LayoutOrgsSchoolsSchoolIdSessionAttendanceRoute,
    LayoutOrgsSchoolsSchoolIdSessionsRoute,
    LayoutOrgsSchoolsSchoolIdSettingsRoute,
    LayoutOrgsSchoolsSchoolIdStudentsRoute,
    LayoutOrgsSchoolsSchoolIdIndexRoute,
    LayoutOrgsSchoolsReportsIndexRoute,
    LayoutPaymentsTeachingPayCycleIdIndexRoute,
    LayoutStudentsStudentIdFutureSessionsIndexRoute,
    LayoutStudentsStudentIdPastStudentFeedbacksIndexRoute,
    LayoutTeachersTeacherIdFutureSessionsIndexRoute,
    LayoutTeachersTeacherIdPastSessionsIndexRoute,
    LayoutTeachersTeacherIdPaymentsIndexRoute,
    LayoutOrgsSchoolsSchoolIdClassesClassIdRoute,
    LayoutOrgsSchoolsSchoolIdOneTimeClassesClassIdRoute,
    LayoutOrgsSchoolsSchoolIdClassesIndexRoute,
    LayoutOrgsSchoolsSchoolIdOneTimeClassesIndexRoute,
    LayoutTeachersTeacherIdPaymentsTeachingPayCycleIdIndexRoute,
  }),
  LoginRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_layout",
        "/login"
      ]
    },
    "/_layout": {
      "filePath": "_layout.tsx",
      "children": [
        "/_layout/403",
        "/_layout/404",
        "/_layout/my-classes",
        "/_layout/",
        "/_layout/lessons/$lessonId",
        "/_layout/payments/guideline",
        "/_layout/sessions/$sessionId",
        "/_layout/teachers-feedback/$feedbackId",
        "/_layout/users/$userId",
        "/_layout/account/",
        "/_layout/books/",
        "/_layout/getting-ready-to-teach/",
        "/_layout/handbook/",
        "/_layout/handouts-and-feedback/",
        "/_layout/lessons/",
        "/_layout/my-availability/",
        "/_layout/my-student-groups/",
        "/_layout/orgs/",
        "/_layout/payments/",
        "/_layout/profile/",
        "/_layout/scheduling/",
        "/_layout/school-students/",
        "/_layout/sessions/",
        "/_layout/student-groups/",
        "/_layout/students/",
        "/_layout/teachers-feedback/",
        "/_layout/teachers/",
        "/_layout/users/",
        "/_layout/books/part/$partId",
        "/_layout/lessons/assessment-contents/$assessmentContentId",
        "/_layout/orgs/$orgId/settings",
        "/_layout/sessions/session-feedbacks/$feedbackId",
        "/_layout/teachers/$teacherId/feedbacks",
        "/_layout/teachers/$teacherId/review-notes",
        "/_layout/teachers/$teacherId/schedule",
        "/_layout/teachers/$teacherId/weekly-teaching-hours",
        "/_layout/books/part/",
        "/_layout/lessons/assessment-contents/",
        "/_layout/lessons/assessments/",
        "/_layout/lessons/learning-paths/",
        "/_layout/orgs/$orgId/",
        "/_layout/orgs/schools/",
        "/_layout/scheduling/schedules/",
        "/_layout/sessions/future/",
        "/_layout/sessions/overlapping/",
        "/_layout/sessions/past/",
        "/_layout/sessions/session-feedbacks/",
        "/_layout/sessions/sub-sessions/",
        "/_layout/student-groups/pending-reassignment/",
        "/_layout/students/$studentId/",
        "/_layout/students/dropped/",
        "/_layout/students/gla/",
        "/_layout/students/learning-issue/",
        "/_layout/students/makeup-diagnostic/",
        "/_layout/students/multiple-schedule/",
        "/_layout/students/no-future-sessions/",
        "/_layout/teachers/$teacherId/",
        "/_layout/teachers/announcement/",
        "/_layout/teachers/attendance/",
        "/_layout/teachers/availabilities/",
        "/_layout/teachers/availability-overview/",
        "/_layout/teachers/google-meet-tq-review/",
        "/_layout/teachers/missing-google-meet/",
        "/_layout/teachers/missing-zoom-license/",
        "/_layout/teachers/onboarding/",
        "/_layout/teachers/teacher-pay/",
        "/_layout/teachers/tq-review/",
        "/_layout/orgs/schools/$schoolId/schedules",
        "/_layout/orgs/schools/$schoolId/session-attendance",
        "/_layout/orgs/schools/$schoolId/sessions",
        "/_layout/orgs/schools/$schoolId/settings",
        "/_layout/orgs/schools/$schoolId/students",
        "/_layout/orgs/schools/$schoolId/",
        "/_layout/orgs/schools/reports/",
        "/_layout/payments/teaching/$payCycleId/",
        "/_layout/students/$studentId/future-sessions/",
        "/_layout/students/$studentId/past-student-feedbacks/",
        "/_layout/teachers/$teacherId/future-sessions/",
        "/_layout/teachers/$teacherId/past-sessions/",
        "/_layout/teachers/$teacherId/payments/",
        "/_layout/orgs/schools/$schoolId/classes/$classId",
        "/_layout/orgs/schools/$schoolId/one-time-classes/$classId",
        "/_layout/orgs/schools/$schoolId/classes/",
        "/_layout/orgs/schools/$schoolId/one-time-classes/",
        "/_layout/teachers/$teacherId/payments/teaching/$payCycleId/"
      ]
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/_layout/403": {
      "filePath": "_layout/403.tsx",
      "parent": "/_layout"
    },
    "/_layout/404": {
      "filePath": "_layout/404.tsx",
      "parent": "/_layout"
    },
    "/_layout/my-classes": {
      "filePath": "_layout/my-classes.tsx",
      "parent": "/_layout",
      "children": [
        "/_layout/my-classes/calendar",
        "/_layout/my-classes/past",
        "/_layout/my-classes/upcoming",
        "/_layout/my-classes/"
      ]
    },
    "/_layout/": {
      "filePath": "_layout/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/lessons/$lessonId": {
      "filePath": "_layout/lessons/$lessonId.tsx",
      "parent": "/_layout"
    },
    "/_layout/my-classes/calendar": {
      "filePath": "_layout/my-classes/calendar.tsx",
      "parent": "/_layout/my-classes"
    },
    "/_layout/my-classes/past": {
      "filePath": "_layout/my-classes/past.tsx",
      "parent": "/_layout/my-classes"
    },
    "/_layout/my-classes/upcoming": {
      "filePath": "_layout/my-classes/upcoming.tsx",
      "parent": "/_layout/my-classes"
    },
    "/_layout/payments/guideline": {
      "filePath": "_layout/payments/guideline.tsx",
      "parent": "/_layout"
    },
    "/_layout/sessions/$sessionId": {
      "filePath": "_layout/sessions/$sessionId.tsx",
      "parent": "/_layout"
    },
    "/_layout/teachers-feedback/$feedbackId": {
      "filePath": "_layout/teachers-feedback/$feedbackId.tsx",
      "parent": "/_layout"
    },
    "/_layout/users/$userId": {
      "filePath": "_layout/users/$userId.tsx",
      "parent": "/_layout"
    },
    "/_layout/account/": {
      "filePath": "_layout/account/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/books/": {
      "filePath": "_layout/books/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/getting-ready-to-teach/": {
      "filePath": "_layout/getting-ready-to-teach/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/handbook/": {
      "filePath": "_layout/handbook/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/handouts-and-feedback/": {
      "filePath": "_layout/handouts-and-feedback/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/lessons/": {
      "filePath": "_layout/lessons/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/my-availability/": {
      "filePath": "_layout/my-availability/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/my-classes/": {
      "filePath": "_layout/my-classes/index.tsx",
      "parent": "/_layout/my-classes"
    },
    "/_layout/my-student-groups/": {
      "filePath": "_layout/my-student-groups/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/orgs/": {
      "filePath": "_layout/orgs/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/payments/": {
      "filePath": "_layout/payments/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/profile/": {
      "filePath": "_layout/profile/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/scheduling/": {
      "filePath": "_layout/scheduling/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/school-students/": {
      "filePath": "_layout/school-students/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/sessions/": {
      "filePath": "_layout/sessions/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/student-groups/": {
      "filePath": "_layout/student-groups/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/students/": {
      "filePath": "_layout/students/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/teachers-feedback/": {
      "filePath": "_layout/teachers-feedback/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/teachers/": {
      "filePath": "_layout/teachers/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/users/": {
      "filePath": "_layout/users/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/books/part/$partId": {
      "filePath": "_layout/books/part/$partId.tsx",
      "parent": "/_layout"
    },
    "/_layout/lessons/assessment-contents/$assessmentContentId": {
      "filePath": "_layout/lessons/assessment-contents/$assessmentContentId.tsx",
      "parent": "/_layout"
    },
    "/_layout/orgs/$orgId/settings": {
      "filePath": "_layout/orgs/$orgId/settings.tsx",
      "parent": "/_layout"
    },
    "/_layout/sessions/session-feedbacks/$feedbackId": {
      "filePath": "_layout/sessions/session-feedbacks/$feedbackId.tsx",
      "parent": "/_layout"
    },
    "/_layout/teachers/$teacherId/feedbacks": {
      "filePath": "_layout/teachers/$teacherId/feedbacks.tsx",
      "parent": "/_layout"
    },
    "/_layout/teachers/$teacherId/review-notes": {
      "filePath": "_layout/teachers/$teacherId/review-notes.tsx",
      "parent": "/_layout"
    },
    "/_layout/teachers/$teacherId/schedule": {
      "filePath": "_layout/teachers/$teacherId/schedule.tsx",
      "parent": "/_layout"
    },
    "/_layout/teachers/$teacherId/weekly-teaching-hours": {
      "filePath": "_layout/teachers/$teacherId/weekly-teaching-hours.tsx",
      "parent": "/_layout"
    },
    "/_layout/books/part/": {
      "filePath": "_layout/books/part/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/lessons/assessment-contents/": {
      "filePath": "_layout/lessons/assessment-contents/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/lessons/assessments/": {
      "filePath": "_layout/lessons/assessments/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/lessons/learning-paths/": {
      "filePath": "_layout/lessons/learning-paths/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/orgs/$orgId/": {
      "filePath": "_layout/orgs/$orgId/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/orgs/schools/": {
      "filePath": "_layout/orgs/schools/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/scheduling/schedules/": {
      "filePath": "_layout/scheduling/schedules/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/sessions/future/": {
      "filePath": "_layout/sessions/future/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/sessions/overlapping/": {
      "filePath": "_layout/sessions/overlapping/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/sessions/past/": {
      "filePath": "_layout/sessions/past/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/sessions/session-feedbacks/": {
      "filePath": "_layout/sessions/session-feedbacks/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/sessions/sub-sessions/": {
      "filePath": "_layout/sessions/sub-sessions/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/student-groups/pending-reassignment/": {
      "filePath": "_layout/student-groups/pending-reassignment/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/students/$studentId/": {
      "filePath": "_layout/students/$studentId/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/students/dropped/": {
      "filePath": "_layout/students/dropped/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/students/gla/": {
      "filePath": "_layout/students/gla/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/students/learning-issue/": {
      "filePath": "_layout/students/learning-issue/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/students/makeup-diagnostic/": {
      "filePath": "_layout/students/makeup-diagnostic/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/students/multiple-schedule/": {
      "filePath": "_layout/students/multiple-schedule/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/students/no-future-sessions/": {
      "filePath": "_layout/students/no-future-sessions/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/teachers/$teacherId/": {
      "filePath": "_layout/teachers/$teacherId/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/teachers/announcement/": {
      "filePath": "_layout/teachers/announcement/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/teachers/attendance/": {
      "filePath": "_layout/teachers/attendance/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/teachers/availabilities/": {
      "filePath": "_layout/teachers/availabilities/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/teachers/availability-overview/": {
      "filePath": "_layout/teachers/availability-overview/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/teachers/google-meet-tq-review/": {
      "filePath": "_layout/teachers/google-meet-tq-review/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/teachers/missing-google-meet/": {
      "filePath": "_layout/teachers/missing-google-meet/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/teachers/missing-zoom-license/": {
      "filePath": "_layout/teachers/missing-zoom-license/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/teachers/onboarding/": {
      "filePath": "_layout/teachers/onboarding/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/teachers/teacher-pay/": {
      "filePath": "_layout/teachers/teacher-pay/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/teachers/tq-review/": {
      "filePath": "_layout/teachers/tq-review/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/orgs/schools/$schoolId/schedules": {
      "filePath": "_layout/orgs/schools/$schoolId/schedules.tsx",
      "parent": "/_layout"
    },
    "/_layout/orgs/schools/$schoolId/session-attendance": {
      "filePath": "_layout/orgs/schools/$schoolId/session-attendance.tsx",
      "parent": "/_layout"
    },
    "/_layout/orgs/schools/$schoolId/sessions": {
      "filePath": "_layout/orgs/schools/$schoolId/sessions.tsx",
      "parent": "/_layout"
    },
    "/_layout/orgs/schools/$schoolId/settings": {
      "filePath": "_layout/orgs/schools/$schoolId/settings.tsx",
      "parent": "/_layout"
    },
    "/_layout/orgs/schools/$schoolId/students": {
      "filePath": "_layout/orgs/schools/$schoolId/students.tsx",
      "parent": "/_layout"
    },
    "/_layout/orgs/schools/$schoolId/": {
      "filePath": "_layout/orgs/schools/$schoolId/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/orgs/schools/reports/": {
      "filePath": "_layout/orgs/schools/reports/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/payments/teaching/$payCycleId/": {
      "filePath": "_layout/payments/teaching/$payCycleId/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/students/$studentId/future-sessions/": {
      "filePath": "_layout/students/$studentId/future-sessions/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/students/$studentId/past-student-feedbacks/": {
      "filePath": "_layout/students/$studentId/past-student-feedbacks/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/teachers/$teacherId/future-sessions/": {
      "filePath": "_layout/teachers/$teacherId/future-sessions/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/teachers/$teacherId/past-sessions/": {
      "filePath": "_layout/teachers/$teacherId/past-sessions/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/teachers/$teacherId/payments/": {
      "filePath": "_layout/teachers/$teacherId/payments/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/orgs/schools/$schoolId/classes/$classId": {
      "filePath": "_layout/orgs/schools/$schoolId/classes/$classId.tsx",
      "parent": "/_layout"
    },
    "/_layout/orgs/schools/$schoolId/one-time-classes/$classId": {
      "filePath": "_layout/orgs/schools/$schoolId/one-time-classes/$classId.tsx",
      "parent": "/_layout"
    },
    "/_layout/orgs/schools/$schoolId/classes/": {
      "filePath": "_layout/orgs/schools/$schoolId/classes/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/orgs/schools/$schoolId/one-time-classes/": {
      "filePath": "_layout/orgs/schools/$schoolId/one-time-classes/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/teachers/$teacherId/payments/teaching/$payCycleId/": {
      "filePath": "_layout/teachers/$teacherId/payments/teaching/$payCycleId/index.tsx",
      "parent": "/_layout"
    }
  }
}
ROUTE_MANIFEST_END */
